module.exports = __webpack_public_path__ + "resources/images/logo-CAV-4b73f9bd960b23b416ec96e687cfc778-cache.jpg";